module.exports = __webpack_public_path__ + "static/failsafe-investing-e3b1494d53c6f31af82e4a08a4aa2e74.jpg";